import { SvgIcon, SvgIconProps } from '@material-ui/core'
import useSvgGradient from '@/CustomIcons/useSvgGradients'

export default function RecordAudioIcon({ withGradient, ...rest }: SvgIconProps & { withGradient?: boolean }) {
    const [gradientId, gradientNode] = useSvgGradient()

    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...rest}>
            {withGradient && gradientNode}
            <path
                d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                fill="none"
                stroke={withGradient ? gradientId : 'currentColor'}
            />
            <path
                d="M12.002 5.42871C15.6311 5.42886 18.5732 8.37079 18.5732 12C18.5731 15.6291 15.631 18.5711 12.002 18.5713C8.37275 18.5713 5.43081 15.6292 5.43066 12C5.43066 8.3707 8.37265 5.42871 12.002 5.42871Z"
                fill={withGradient ? gradientId : 'currentColor'}
                stroke={withGradient ? gradientId : 'currentColor'}
                strokeWidth="0.571429"
            />
        </SvgIcon>
    )
}
